import { IMessage, IContact } from '../schemas/entity_set';
import { IRequestResult } from "../schemas/structure"
import { IMessageService, IMessageFilter } from './message_service';
import { Toast } from '../helpers/message_box';
import { AppServices } from '../helpers/config_keys';
import { IAuthService } from '../authentication/auth_service';

let _ = require("underscore");

class MessagePortalCtrl {
    theMessage: IMessage;
    messages: IMessage[];
    newMessage: IMessage;

    //Pager Config
    totalRecords = 0;
    currentPage = 1;
    recordSize = 6;
    totalPages = 1;
    lastFilter: IMessageFilter;

    //Loading Indicators
    sending: boolean;
    deleting: boolean;
    loading: boolean;
    minDate = new Date();


    static $inject = [AppServices.MessageService, AppServices.AuthService];
    constructor(private messageService: IMessageService, private authService: IAuthService) {
        this.fetchMessages(<IMessageFilter>{ pager: { page: 1, size: this.recordSize } })
    }

    setLabel(status: string) {
        switch (status) {
            case "Sent":
                return "label-success";
            case "Scheduled":
                return "label-warning";
            default:
                return "label-danger";
        }
    }

    pageChanged(page: number) {
        this.currentPage = page;
        this.lastFilter.pager.page = page;
        this.loading = true
        this.messageService.query(this.lastFilter).then((res) => {
            this.loading = false
            if (res.success) { this.messages = res.data }
        })
    };

    fetchMessages(filter: IMessageFilter) {
        this.loading = true
        filter.pager = filter.pager || { page: 1, size: this.recordSize }
        this.lastFilter = angular.copy(filter)
        this.messageService.query(filter).then((res) => {
            this.loading = false
            if (res.success) {
                this.messages = res.data
                this.totalRecords = res.total;
                this.totalPages = Math.ceil(res.total / this.recordSize);
            }
        })
    }

    createMessage() { this.newMessage = <IMessage>{ type: "Sms" } }

    cancelMessage() { this.newMessage = null }

    openMessage(message: IMessage) { this.theMessage = angular.copy(message) }

    closeMessage() { this.theMessage = null }

    sendMessage() {
        let message = angular.copy(this.newMessage);
        message.contacts = this.refactorContacts()
        this.sending = true
        this.messageService.sendBulkMessage(message).then((res) => {
            this.sending = false
            if (res.success) {
                this.cancelMessage()
                this.fetchMessages(this.lastFilter)
            }
        })
    }

    resend(messageId: number) {
        this.sending = true
        this.messageService.resend(messageId).then((res) => {
            this.sending = false
            this.fetchMessages(this.lastFilter)
            Toast.display(res.message, res.success)
        })
    }

    contactConfig() {
        return {
            placeholder: "Search contact or group name...",
            allowClear: true,
            minimumInputLength: 3,
            multiple: true,
            ajax: {
                url: "/api/message/fetchcontacts",
                dataType: "json",
                data: (term: string, page: number) => {
                    return { q: term };
                },
                results: (response: IRequestResult<Array<IContact>>, page: number) => {
                    return { results: response.data };
                },
                cache: true,
                params: {
                    headers: {
                        "Authorization": "Bearer " + this.authService.currentUser.token,
                        "Content-Type": "application/json",
                    }
                },
            },
            formatResult: (contact: IContact) => {
                return `<div class='row-fluid'><div><div class='row-fluid'>
                <div><strong> ${contact.name}</strong></div>
                <div>${contact.info}</div>
                </div></div></div>`
            },
            formatSelection: function (contact: IContact) {
                return contact.name;
            },
            dropdownCssClass: "bigdrop"
        }
    }


    private refactorContacts() {
        let data = _.map(this.newMessage.contacts.toString().split(","), (contactStr: string) => {
            var c = contactStr.split(" ");
            return { recordId: +c[0], type: c[1] };
        });
        return <IContact[]>data;
    }

}

export { MessagePortalCtrl }


// WEBPACK FOOTER //
// ./app/messenger/message_portal_ctrl.ts